import { render } from "./ExternalExamAttachmentsTab.vue?vue&type=template&id=34030b35&scoped=true"
import script from "./ExternalExamAttachmentsTab.vue?vue&type=script&lang=js"
export * from "./ExternalExamAttachmentsTab.vue?vue&type=script&lang=js"

import "./ExternalExamAttachmentsTab.vue?vue&type=style&index=0&id=34030b35&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34030b35"]])

export default __exports__